export const PLACE_RULE_FOOTPRINT_RADIUS_MILES = 0.0125

export const createPlacePolygon = (lat, lng, radiusMiles = PLACE_RULE_FOOTPRINT_RADIUS_MILES) => {
  const latitude = Number(lat)
  const longitude = Number(lng)
  const radius = Number(radiusMiles)

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || !Number.isFinite(radius)) {
    return []
  }

  const latDelta = radius / 69
  const cosine = Math.cos((latitude * Math.PI) / 180)
  const lngDelta = radius / (Math.max(Math.abs(cosine), 0.01) * 69)

  return [
    { lat: latitude - latDelta, lng: longitude - lngDelta },
    { lat: latitude + latDelta, lng: longitude - lngDelta },
    { lat: latitude + latDelta, lng: longitude + lngDelta },
    { lat: latitude - latDelta, lng: longitude + lngDelta },
    { lat: latitude - latDelta, lng: longitude - lngDelta },
  ]
}
